import Link from 'next/link'; 
import {downloadLink } from '@/lib/utils.js'
import parse from 'html-react-parser'; 
import {renderAtKey, positionHTML  } from '@/components/customizable_area_utilities'
import ResourceSection from '@/components/resources_section.js'
import AttributeSection from '@/components/attribute_section.js'
import {useContext} from 'react'; 
import {CartContext} from '@/lib/cart_context.js' 


export default function CustomizableResourcesArea({primarySpecSheet,  product, resource_display, config }) {

 const cart = useContext(CartContext);
 const cartActive = cart?.itemInCart
 const itemInCart = cartActive &&  cart.itemInCart(product.id); 

 const productOpts = {primarySpecSheet: primarySpecSheet, cartActive: cartActive, 
   itemInCart: itemInCart, cart: cart, product:  product, resource_display: resource_display, config: config}

    const defaultHTML = ( ) => {
      return ( 
        <>
      <h3 className="lexcms-product-section-heading">Resources</h3>
      <div className="lexcms-product-resources-content">
        <ResourceSection downloads={product.downloads} product={product} resource_display={resource_display} config={config} />
        <div className="lexcms-product-resources-custom-text-and-attributes-section">

          {product.construction_text && (
            <div className="lexcms-product-custom-text">
              <div dangerouslySetInnerHTML={{ __html: product.construction_text }} />
            </div>
          )}
          {product.electrical_text && (
            <div className="lexcms-product-custom-text">
              <div dangerouslySetInnerHTML={{ __html: product.electrical_text }} />
            </div>
          )}
          {product.more_about_text && (
            <div className="lexcms-product-custom-text">
              <div dangerouslySetInnerHTML={{ __html: product.more_about_text }} />
            </div>
          )}
          <AttributeSection attributes={product.attributes }/>
        </div>
      </div>
    </>
      )
    }

  return (
    <>
      {positionHTML('beforebegin', 'resources_area', productOpts)}
      <div className='lexcms-resources-area'>
        {positionHTML('afterbegin', 'resources_area',  productOpts)}
        {!positionHTML('replace', 'resources_area',  productOpts)  &&
            defaultHTML()
        }
        {positionHTML('replace', 'resources_area',  productOpts)}
        {positionHTML('beforeend', 'resources_area',  productOpts)}
      </div>
      {positionHTML('afterend', 'resources_area', productOpts)}
    </>
  )
}

